import React, {Component} from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactPlayer from 'react-player'
import Navigation from './Navigation';
import Header from './Header';

class CharacterPreview extends Component{
	constructor(props){
		super(props);

		this.state = {
			videoView: null
		}
	}
	
	componentWillMount(){
	}

	componentDidMount() {		
		this.makeVideoSlider();
	}

	makeVideoSlider() {
		let videos = this.props.videoUrlList.map((video, index) => {
			return (<ReactPlayer key={index} url={video} controls />);
		})

		if (this.props.videoUrlList.length) {
			this.setState({
				videoView: videos
			})
		} else {
			this.setState({
				videoView: null
			})
		}
	}

	temp_func() {
		let backStyle = {
				backgroundImage: "url('/assets/images/game-assest.png')"
			}
		return (
				<div className="col-lg-3 col-md-6 col-sm-3 col-6 characterAsset">
					<div className="assetItem">
						<div className="assetImage" style={backStyle}></div>
						<div className="btn_wrap">
							<button className="close_asset"></button>
						</div>
						<div className="assetname">{this.props.dataLanguage['ripper']}</div>
					</div>
				</div>
			);
	}

	setLanguage(lang) {
	}

	checkLogin() {
	}

	render(){
		return(
			<div className="digit character preview">
				<Header history={this.props.history} ref="header" dataLanguage={this.props.dataLanguage} setLanguage={this.setLanguage.bind(this)} checkLogin={this.checkLogin.bind(this)} preview={false} />
				<div>
					<section className="banner">
						<div className="container">
							<Navigation active="2" dataLanguage={this.props.dataLanguage} />

							<div className="characterName">
								<p>{this.props.characterName}</p>
							</div>
							<div className="row">
								<div className="col-md-6">
									{ this.props.characterImage ?
										<div className="characterImage">
											<img src={this.props.characterImage} alt={this.state.characterName} />
										</div>
									: null }
								</div>
								<div className="col-md-6">
									<div className="row characterAssetWrap">
										<div className="col-lg-3 col-md-6 col-sm-3 col-6 characterAsset">
											<div className="btn_select_asset_out">
												<button className="btn_select_asset"></button>
											</div>
										</div>
									</div>
								</div>
							</div>

							
							<div className="row character_info">
								<div className="col-md-6">
									<div className="border_yellow">
										<div className="text_part">
											<div className="row fixed_info">
												<div className="col-md-6 text-center">
													<p><span className="text-yellow">Level:</span> { this.props.characterLevel }</p>
													<p><span className="text-yellow">Class:</span> { this.props.characterClass }</p>
												</div>
												<div className="col-md-6 text-center">
													<p><span className="text-yellow">Race:</span> { this.props.characterRace }</p>
													<p><span className="text-yellow">Gender:</span> { this.props.characterGender }</p>
												</div>
											</div>
										</div>
										<div className="text_part back_yellow text-center">
											<p>{this.props.dataLanguage['agg_time_played']}</p>
										</div>
										<div className="text_part text-center">
											<p className="text-yellow">{this.props.dataLanguage['enter_character_creation_date']}</p>
											<input type="date" />
										</div>
									</div>
								</div>
								<div className="col-md-6">
									<div className="border_yellow">
										<div className="text_part back_yellow text-center">
											<p>{this.props.dataLanguage['total_assets']}:</p>
										</div>
										<div className="text_part text-center">
											<p className="text-green">0</p>
										</div>
										<div className="text_part back_yellow text-center">
											<p>{this.props.dataLanguage['agg_asset_value']}</p>
										</div>
										<div className="text_part text-center">
											<p className="text-green">$00.00</p>
										</div>
										<div className="currency_info">
											<div className="row">
												<div className="col-md-6 col-6 text-center">
													<div className="col-12">
														<p className="text-yellow">{this.props.dataLanguage['in_game_currency']}</p>
														<input type="number" className="" />
													</div>
												</div>
												<div className="col-md-6 col-6 text-center">
													<div className="col-12">
														<p className="text-yellow">{this.props.dataLanguage['real_world_value']}</p>
														<p className="text-green">$00.00</p>
													</div>
												</div>
											</div>
											<img className="converter" alt="converter" src="/assets/images/converter-fill.png" />
										</div>
									</div>
								</div>
							</div>

							{ this.state.videoView ?
								<div className="banner-slider video-slider">
									<div className="owl-slider">
										<OwlCarousel id="videoSlider" items={1} className="owl-theme" loop nav margin={1} responsiveClass={true} >
											{ this.state.videoView }
										</OwlCarousel>
									</div>
								</div>
							: null }
						</div>
					</section>
				</div>
			</div>
		)
	}
}

export default CharacterPreview;


// WEBPACK FOOTER //
// ./src/components/CharacterPreview.js